import React from 'react';

// Shared "average daily usage" summary box used by both the line and bar
// usage charts. placement 'top'/'bottom' overlays the chart (parent must be
// position: relative); 'above' renders in normal flow before the chart.
export const AverageUsageSummary = ({
  baselineAverage,
  experimentAverage,
  unit,
  placement = 'top',
}) => {
  const baseline = Number.isFinite(baselineAverage) ? baselineAverage : 0;
  const experiment = Number.isFinite(experimentAverage) ? experimentAverage : 0;
  const percentOfBaseline =
    baseline !== 0 && experiment !== 0 ? (100 * experiment) / baseline : 0;

  const placementStyle =
    placement === 'above'
      ? { width: 'fit-content', margin: '0 auto 10px' }
      : {
          position: 'absolute',
          ...(placement === 'bottom' ? { bottom: '10%' } : { top: '10%' }),
          left: '10%',
        };

  return (
    <div style={{
      ...placementStyle,
      background: 'rgba(255, 255, 255, 0.8)',
      color: 'black',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: '5px',
      padding: '10px',
      boxSizing: 'border-box',
    }}>
      <div>
        <strong>Average daily usage</strong>
      </div>
      <div>
        <strong>Baseline: </strong>
        {baseline.toFixed(2)} {unit}
      </div>
      <div>
        <strong>Experiment: </strong>
        {experiment.toFixed(2)} {unit}
      </div>
      <div>
        <strong>% of Baseline: </strong>
        {percentOfBaseline.toFixed(2)} %
      </div>
    </div>
  );
};
